// extracted by mini-css-extract-plugin
module.exports = {"firstServiceDiscountCode":"M41qtR9tzNjbBIqCauVslQ==","firstServiceDiscountCodeText":"_3UZFWYW7X1JM3eD0D9SZwA==","firstServiceDiscountCodeCopy":"rxGIN85FnXNsDhCJYQQWlA=="};